import { IFaireMoney } from '../../../indigofair/data/IFaireMoney';

export namespace IExclusivityAvailabilityState {
  export enum State {
    STATE_UNKNOWN = 'STATE_UNKNOWN',
    /**
     * brand has exclusivity enabled, but this retailer has not activated an exclusivity relationship
     */
    AVAILABLE = 'AVAILABLE',
    /**
     * brand has active exclusivity relationship and option to cancel with this retailer
     */
    PENDING = 'PENDING',
    /**
     * Brand has an active exclusivity agreement with this retailer, and both brand and retailer are committed
     */
    ACTIVE = 'ACTIVE',
    /**
     * retailer is unable to purchase from this brand due to exclusivity agreement of another retailer
     */
    BLOCKED = 'BLOCKED',
    /**
     * brand does not have exclusivity enabled, and retailer has not requested exclusivity
     */
    NOT_ENABLED = 'NOT_ENABLED',
    /**
     * retailer is not eligible for exclusivity with this brand (even if brand has exclusivity enabled)
     */
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    /**
     * brand does not have exclusivity enabled, and retailer has requested exclusivity
     */
    REQUESTED = 'REQUESTED',
    /**
     * brand has blocked all purchases in this zipcode
     */
    ZIPCODE_BLOCKED = 'ZIPCODE_BLOCKED',
    /**
     * retailer has an unsettled agreement with the brand
     */
    UNSETTLED_AGREEMENT = 'UNSETTLED_AGREEMENT',
  }

  /**
   * Return an instance of IExclusivityAvailabilityState with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IExclusivityAvailabilityState>
  ): IExclusivityAvailabilityState =>
    ({
      ...(partial ?? {}),
    }) as IExclusivityAvailabilityState;
}

export interface IExclusivityAvailabilityState {
  /**
   * @protobufOption (.faire.common.tokenType) = BRAND
   */
  brand_token: string | undefined;
  state: keyof typeof IExclusivityAvailabilityState.State | undefined;
  is_ending_soon: boolean | undefined;
  commitment_spend: IFaireMoney | undefined;
}
